import { useCallback, useEffect, useState } from 'react';
import { listItems } from '@/modules/inventory/services';
import type { InventoryItem } from '@/modules/inventory/types';

export function useItems() {
  const [items, setItems] = useState<InventoryItem[]>([]);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState<string | null>(null);

  const refresh = useCallback(async () => {
    setLoading(true);
    setError(null);
    try {
      setItems(await listItems());
    } catch {
      setError('No se pudieron cargar los artículos.');
    } finally {
      setLoading(false);
    }
  }, []);

  useEffect(() => {
    void refresh();
  }, [refresh]);

  return { items, loading, error, refresh };
}
